import { IRenderFormField } from "src/@types/form";
import {
  COMPANY_NAME_ADDRESS_SITE_FIELDS,
  DESCRIPTION_FIELD,
  FOUNDING_DOCS_FIELD,
  getCountryField,
  getIndustryField,
  getReprecentionCountriesField,
  INTERNATIONAL_FIELD,
  NAMES_FIELDS,
  PHONE_EMAIL_PASSWORD_FIELDS,
  ROLE_FIELD,
} from "./fields";
import {
  BriefInfo,
  ChooseIndustry,
  CompanyInfo,
  CountryOfRegistration,
  FoundingDocuments,
  LoggingInData,
  PresentedInternationally,
  RegisteringAs,
  ResponsiblePerson,
  WhereProductsRepresented,
} from "../Steps";
import { registrationButtonsTrns } from "../trns";
import { IStep, RegistrationFields } from "../types";

const getNames = (field: IRenderFormField) => field.name as RegistrationFields;
const getStepTitle = (count: string) => ({
  i18nKey: registrationButtonsTrns.stepButton,
  i18nParams: { count },
});

export const STEP_ITEMS_FOR_OWNER: IStep[] = [
  {
    id: "1",
    responsibleFields: ROLE_FIELD.map(getNames),
    stepTitle: getStepTitle("I"),
    stepComponent: RegisteringAs,
  },
  {
    id: "2",
    responsibleFields: getCountryField().map(getNames),
    stepTitle: getStepTitle("II"),
    stepComponent: CountryOfRegistration,
  },
  {
    id: "3",
    responsibleFields: COMPANY_NAME_ADDRESS_SITE_FIELDS.map(getNames),
    stepTitle: getStepTitle("III"),
    stepComponent: CompanyInfo,
  },
  {
    id: "4",
    responsibleFields: NAMES_FIELDS.map(getNames),
    stepTitle: getStepTitle("IV"),
    stepComponent: ResponsiblePerson,
  },
  {
    id: "5",
    responsibleFields: DESCRIPTION_FIELD.map(getNames),
    stepTitle: getStepTitle("V"),
    stepComponent: BriefInfo,
  },
  {
    id: "6",
    // no options needed; extracting only the name field
    responsibleFields: getIndustryField().map(getNames),
    stepTitle: getStepTitle("VI"),
    stepComponent: ChooseIndustry,
  },
  {
    id: "7",
    responsibleFields: INTERNATIONAL_FIELD.map(getNames),
    stepTitle: getStepTitle("VII"),
    stepComponent: PresentedInternationally,
  },
  {
    id: "8",
    // no options needed; extracting only the name field
    responsibleFields: getReprecentionCountriesField().map(getNames),
    stepTitle: getStepTitle("VIII"),
    stepComponent: WhereProductsRepresented,
  },
  {
    id: "9",
    responsibleFields: PHONE_EMAIL_PASSWORD_FIELDS.map(getNames),
    stepTitle: getStepTitle("IX"),
    stepComponent: LoggingInData,
  },
];

export const STEP_ITEMS_FOR_AGENT: IStep[] = [
  {
    id: "1",
    responsibleFields: ROLE_FIELD.map(getNames),
    stepTitle: getStepTitle("I"),
    stepComponent: RegisteringAs,
  },
  {
    id: "2",
    // no options needed; extracting only the name field
    responsibleFields: getCountryField().map(getNames),
    stepTitle: getStepTitle("II"),
    stepComponent: CountryOfRegistration,
  },
  {
    id: "3",
    responsibleFields: COMPANY_NAME_ADDRESS_SITE_FIELDS.map(getNames),
    stepTitle: getStepTitle("III"),
    stepComponent: CompanyInfo,
  },
  {
    id: "4",
    responsibleFields: NAMES_FIELDS.map(getNames),
    stepTitle: getStepTitle("IV"),
    stepComponent: ResponsiblePerson,
  },
  {
    id: "5",
    responsibleFields: DESCRIPTION_FIELD.map(getNames),
    stepTitle: getStepTitle("V"),
    stepComponent: BriefInfo,
  },
  {
    id: "6",
    responsibleFields: FOUNDING_DOCS_FIELD.map(getNames),
    stepTitle: getStepTitle("VI"),
    stepComponent: FoundingDocuments,
  },
  {
    id: "7",
    responsibleFields: PHONE_EMAIL_PASSWORD_FIELDS.map(getNames),
    stepTitle: getStepTitle("VII"),
    stepComponent: LoggingInData,
  },
];
